import { useEffect } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    Container,
    Divider,
    Grid,
    Stack,
    Typography,
} from "@mui/material";

import {
    Security,
    MailOutline,
    Description,
    Bolt,
    CheckCircle,
    ArrowForward,
} from "@mui/icons-material";

import HeaderDashboard from "../../../components/HeaderDashboard";
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import HomeIcon from '@mui/icons-material/Home';
import { Breadcrumbs, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../../contexts/UserContext";



const ApresentacaoEnderecoFiscal = () => {
    const navigate = useNavigate();
    const { user } = useUser();

    useEffect(() => {
        window.scrollTo(0, 0);
        if (user?.assinaturaEnderecoFiscal) {
            navigate("../dashboard/residenciaFiscal");
        }
    }, []);
    const benefits = [
        {
            icon: <Security style={{ color: "#2EF07C" }} />,
            title: "Privacidade",
            description: "Proteja seu endereço residencial."
        },
        {
            icon: <MailOutline style={{ color: "#2EF07C" }} />,
            title: "Correspondências",
            description: "Recebimento e gestão das notificações."
        },
        {
            icon: <Bolt style={{ color: "#2EF07C" }} />,
            title: "Ativação rápida",
            description: "Processo simples e totalmente online."
        },
        {
            icon: <Description style={{ color: "#2EF07C" }} />,
            title: "Contrato Digital",
            description: "Assinatura eletrônica com validade jurídica."
        }
    ];


    return (
        <>
            <HeaderDashboard />
            <div style={{ padding: "30px", background: "#f4f6f8", minHeight: "100vh", marginTop: "64px" }}>
                <div style={{ width: "100%", height: "fit-content", padding: "10px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                        <div style={{ width: "80%" }}>
                            <Breadcrumbs aria-label="breadcrumb">
                                <Link
                                    underline="hover"
                                    sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                    color="inherit"
                                    onClick={() => navigate("../dashboard")}
                                >
                                    <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Dashboard
                                </Link>
                                <Typography
                                    sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                                >
                                    <AssignmentTurnedInIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                    Endereço Fiscal
                                </Typography>
                            </Breadcrumbs>
                        </div>
                    </div>
                </div>
                <Container maxWidth="xl">
                    <Grid container spacing={4}>

                        {/* HERO */}

                        <Grid size={{ xs: 12, md: 8 }}>

                            <Card
                                sx={{
                                    borderRadius: 5,
                                    bgcolor: "#222",
                                    color: "#FFF",
                                    height: "100%"
                                }}
                            >

                                <CardContent sx={{ p: 5 }}>

                                    <Chip
                                        label="VIRTUAL OFFICE SOLUTIONS"
                                        style={{
                                            backgroundColor: "#2EF07C",
                                            color: "#000",
                                            fontWeight: 700,
                                            borderRadius: 5,
                                            padding: "5px 10px",
                                            fontSize: "12px"
                                        }}
                                        size="small"
                                    />

                                    <Typography
                                        variant="h3"
                                        fontWeight={700}
                                        mt={3}
                                    >
                                        Endereço Fiscal
                                    </Typography>

                                    <Typography
                                        mt={2}
                                        color="grey.400"
                                        sx={{
                                            maxWidth: 650
                                        }}
                                    >
                                        Utilize nosso endereço para registrar sua empresa
                                        com segurança e total privacidade.
                                        Ideal para empresas digitais e profissionais
                                        que desejam separar sua vida pessoal da empresa.
                                    </Typography>

                                    <Grid container spacing={2} mt={3}>

                                        {benefits.map((item) => (

                                            <Grid size={{ xs: 12, sm: 6 }} key={item.title}>

                                                <Card
                                                    sx={{
                                                        bgcolor: "rgba(255,255,255,.05)",
                                                        color: "#FFF",
                                                        borderRadius: 3
                                                    }}
                                                >

                                                    <CardContent>

                                                        <Stack
                                                            direction="row"
                                                            spacing={2}
                                                            alignItems="center"
                                                        >

                                                            {item.icon}

                                                            <Box>

                                                                <Typography
                                                                    fontWeight={600}
                                                                >
                                                                    {item.title}
                                                                </Typography>

                                                                <Typography
                                                                    variant="body2"
                                                                    color="grey.400"
                                                                >
                                                                    {item.description}
                                                                </Typography>

                                                            </Box>

                                                        </Stack>

                                                    </CardContent>

                                                </Card>

                                            </Grid>

                                        ))}

                                    </Grid>

                                    <Stack
                                        direction="row"
                                        spacing={2}
                                        mt={5}
                                    >

                                        <Button
                                            variant="contained"
                                            size="large"
                                            endIcon={<ArrowForward />}
                                            onClick={() => navigate("../dashboard/assinarContratoEnderecoFiscal")}
                                            sx={{
                                                borderRadius: 3,
                                                px: 5,
                                                backgroundColor: "#2EF07C",
                                                color: "#000",
                                            }}
                                        >
                                            Contratar Agora
                                        </Button>

                                    </Stack>

                                    <Stack
                                        direction="row"
                                        spacing={4}
                                        mt={4}
                                    >

                                        <Typography
                                            variant="body2"
                                            color="grey.500"
                                        >
                                            ⏱ Contratação em menos de 3 minutos
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            color="grey.500"
                                        >
                                            🔒 Dados protegidos pela LGPD
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            color="grey.500"
                                        >
                                            📄 Assinatura Digital
                                        </Typography>
                                    </Stack>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* PREÇO */}

                        <Grid size={{ xs: 12, md: 4 }}>

                            <Card
                                sx={{
                                    borderRadius: 5,
                                    mb: 3
                                }}
                            >

                                <CardContent>

                                    <Typography
                                        align="center"
                                        color="text.secondary"
                                    >
                                        MENSALIDADE
                                    </Typography>

                                    <Typography
                                        align="center"
                                        variant="h2"
                                        fontWeight={700}
                                    >
                                        R${user?.enderecoFiscal?.valor.toFixed(2).replace(".", ",") || "..."}
                                    </Typography>

                                    <Typography
                                        align="center"
                                        color="text.secondary"
                                    >
                                        /mês
                                    </Typography>

                                    <Divider sx={{ my: 3 }} />

                                    <Stack spacing={2}>

                                        {[
                                            "Proteção do endereço residencial",
                                            "Aceito para abertura da empresa",
                                            "Recebimento de correspondências",
                                            "Gestão feita pela ContBlack"
                                        ].map((item) => (

                                            <Stack
                                                key={item}
                                                direction="row"
                                                spacing={1}
                                                alignItems="center"
                                            >
                                                <CheckCircle
                                                    color="success"
                                                    fontSize="small"
                                                />

                                                <Typography>
                                                    {item}
                                                </Typography>

                                            </Stack>

                                        ))}

                                    </Stack>

                                </CardContent>

                            </Card>

                            <Card
                                sx={{
                                    bgcolor: "#F8EFFF",
                                    borderRadius: 5
                                }}
                            >

                                <CardContent>

                                    <Typography
                                        color="secondary"
                                        fontWeight={700}
                                        mb={2}
                                    >
                                        Aviso Importante
                                    </Typography>

                                    <Typography
                                        color="text.secondary"
                                    >
                                        O endereço fiscal destina-se exclusivamente ao
                                        registro da empresa e ao recebimento de
                                        correspondências.

                                        <br /><br />

                                        Não é permitido atendimento presencial,
                                        armazenamento de mercadorias ou recebimento de
                                        clientes no local.
                                    </Typography>

                                </CardContent>

                            </Card>

                        </Grid>

                    </Grid>

                </Container>
            </div>

        </>
    );
}

export default ApresentacaoEnderecoFiscal;